// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"_2g_Fr"};